import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { finalize, map, Observable } from "rxjs";
import { EncryptionService } from "./services/shared-services/encryption.service";
import { ApiConfig } from "./apiConfig";
import { environment } from "src/environments/environment";

@Injectable()
export class EncryptionInterceptor implements HttpInterceptor {
    constructor(
        private encryptionService: EncryptionService
    ) { }
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (req.method == "POST") {
            let encryptedPayload;

            // File uploads (multipart) must be sent plain — the request body itself can't be
            // JSON-encrypted since it's a real multipart upload, not a JSON payload.
            const isFormData = req.body instanceof FormData;

            if (isFormData) {
                encryptedPayload = req.body;
            } else {
                encryptedPayload = this.encryptionService.encryptPayload(JSON.stringify(req.body));

            }
            const encryptedReq = req.clone({
                body: encryptedPayload,
            });

            return next.handle(encryptedReq).pipe(
                map((event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        // Whether the RESPONSE is encrypted depends on which backend served the
                        // request, not on whether the request itself was FormData - e.g. SelfCareService's
                        // FileReceiver returns a plain response, but SMSScheduler's FileReceiver
                        // (same endpoint name, different service) encrypts its response even for a
                        // FormData upload. So decide based on the actual response shape instead of
                        // assuming from the request type.
                        const body: any = event.body;
                        const looksEncrypted = !!body && typeof body === "object" && "Payload" in body && "PublicKey" in body;

                        if (!looksEncrypted) {
                            // Genuinely plain response — pass through as-is.
                            return event;
                        }

                        const decryptedResponse = this.encryptionService.decryptResponse(
                            event.body
                        );
                        const decryptedEvent = event.clone({
                            body: JSON.parse(decryptedResponse),
                        });

                        return decryptedEvent;
                    }
                    return event;
                })
            );
        }
        else {
            return next.handle(req);
        }
    }
}